import { phoneModes } from '../constants/phone.constants';
import { useContactStore } from '../features/dialer/store/contact.store';
import { useDeviceStore } from '../store/device.store';
import { useDialerCallPulseStore } from '../store/dialer-call-pulse.store';
import { useDialerStore } from '../store/dialer.store';
import { usePhoneStore } from '../store/phone.store';

export const usePhone = () => {
  const phoneStore = usePhoneStore();
  const dialerStore = useDialerStore();
  const contactStore = useContactStore();
  const deviceStore = useDeviceStore();
  const dialerCallPulseStore = useDialerCallPulseStore();

  const closePhone = () => {
    deviceStore?.call?.disconnect();
    deviceStore?.call?.ignore();
    deviceStore?.updateAcceptedTimestamp('');
    phoneStore.resetPhone();
    dialerStore.resetDialer();
    contactStore.resetContact();
    dialerCallPulseStore.resetDialerCallPulse();
    deviceStore.resetCall();
  };

  const handleTabSelect = (openTab: VoidFunction, shouldOpenInCallView?: boolean) => {
    openTab();
    contactStore.resetContact();
    if (phoneStore.mode !== phoneModes.dialer) phoneStore.openDialer();

    // when there is no active call or the clicked tab is not dialer, do nothing
    if (!deviceStore.call || !shouldOpenInCallView) return;

    if (phoneStore.isIncoming) phoneStore.openIncomingPhone(false);
    else phoneStore.openPhoneInCallMode();
  };

  const collapsePhone = () => {};

  return { closePhone, handleTabSelect, collapsePhone };
};
